'use client';

import React, { useState, useEffect } from 'react';

const navLinks = [
  { label: 'Home / Contact', href: '#hero' },
  { label: 'About Us', href: '#about' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (!mobileOpen) return;
    const handler = () => setMobileOpen(false);
    window.addEventListener('scroll', handler, { passive: true });
    return () => window.removeEventListener('scroll', handler);
  }, [mobileOpen]);

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
          scrolled
            ? 'bg-[#FAF9F6]/95 backdrop-blur-xl border-b border-[#E8DED1] shadow-sm'
            : 'bg-transparent'
        }`}
        role="banner"
      >
        <div className="max-w-7xl mx-auto px-6 lg:px-12 h-16 flex items-center justify-between">
          {/* Logo */}
          <a
            href="/"
            className="font-display text-lg font-semibold tracking-wide hover:opacity-70 transition-opacity"
            style={{ color: scrolled ? '#0F1C2E' : '#0F1C2E' }}
            aria-label="John Keith Shutters — home"
          >
            <span className={scrolled ? 'text-[#0F1C2E]' : 'text-white'}>John Keith Shutters</span>
          </a>

          {/* Desktop nav */}
          <div className="flex items-center gap-8">
            {navLinks?.map((link) => (
              <a
                key={link?.href}
                href={link?.href}
                className={`hidden md:block text-sm font-medium tracking-wide transition-colors ${
                  scrolled
                    ? 'text-[#0F1C2E] hover:text-[#7B8A94]'
                    : 'text-white/90 hover:text-white'
                }`}
              >
                {link?.label}
              </a>
            ))}

            <a
              href="#contact"
              className="hidden sm:block bg-[#0F1C2E] text-[#FAF9F6] text-sm font-medium px-5 py-2.5 rounded-full hover:bg-[#1B3A5C] transition-colors"
            >
              Get a Free Quote
            </a>

            {/* Mobile toggle */}
            <button
              className={`sm:hidden w-10 h-10 rounded-full flex items-center justify-center transition-colors ${
                scrolled ? 'text-[#0F1C2E] hover:bg-[#E8DED1]' : 'text-white hover:bg-white/10'
              }`}
              onClick={() => setMobileOpen((v) => !v)}
              aria-label={mobileOpen ? 'Close menu' : 'Open menu'}
              aria-expanded={mobileOpen}
            >
              {mobileOpen ? (
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M18 6L6 18M6 6l12 12" />
                </svg>
              ) : (
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M3 12h18M3 6h18M3 18h18" />
                </svg>
              )}
            </button>
          </div>
        </div>
      </header>
      {/* Mobile menu */}
      {mobileOpen && (
        <div
          className="fixed inset-0 z-40 bg-[#0F1C2E]/97 backdrop-blur-xl flex flex-col justify-center items-center gap-8 sm:hidden"
          role="dialog"
          aria-modal="true"
        >
          <button
            className="absolute top-5 right-6 w-10 h-10 rounded-full flex items-center justify-center text-white hover:bg-white/10 transition-colors"
            onClick={() => setMobileOpen(false)}
            aria-label="Close menu"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M18 6L6 18M6 6l12 12" />
            </svg>
          </button>

          <nav className="flex flex-col items-center gap-6">
            {navLinks?.map((link) => (
              <a
                key={link?.href}
                href={link?.href}
                onClick={() => setMobileOpen(false)}
                className="text-2xl font-display font-medium text-white/80 hover:text-[#E8DED1] transition-colors"
              >
                {link?.label}
              </a>
            ))}
          </nav>

          <a
            href="#contact"
            onClick={() => setMobileOpen(false)}
            className="mt-4 inline-flex items-center gap-2 px-8 py-4 rounded-full bg-white text-[#0F1C2E] font-semibold text-base hover:bg-[#E8DED1] transition-all"
          >
            Get a Free Quote
          </a>
        </div>
      )}
    </>
  );
}